import axiosInstance from "../../../helpers/api";

export const getAllQuestionsBank = (id) => {
    return axiosInstance.get(`/admin/bank_questions?chapter_id=${id}`);
};

export const editQuestionBank = (formData) => {
    return axiosInstance.post(`/admin/bank_questions/${formData.id}`, formData.formData);
};


export const createQuestionBank = (formData) => {
    return axiosInstance.post('/admin/bank_questions', formData);
};

export const deleteQuestionBank = (id) => {
    return axiosInstance.delete(`/admin/bank_questions/${id}`);
};

export const hardDeleteQuestionBank = (id) => {
    return axiosInstance.delete(`/admin/bank_questions/hard_delete/${id}`);
};

export const bookmarkQuestionBank = (id) => {
    return axiosInstance.get(`/admin/bank_questions/book_mark/${id}`);
};

export const getTopMissedQuestionsForAdmin = () => {
    return axiosInstance.get('/admin/bank_questions/top-missed-questions');
};

export const updateQuestionTags = (id, tags) => {
    return axiosInstance.put(`/admin/bank_questions/update-question-tags/${id}`, { tags });
};
